<script setup lang="ts">
const showPopup = defineModel('showPopup');

const handleClick = () => {
  showPopup.value = false;
};
</script>

<template>
  <div class="wrong-sex-card">
    <p>驗證碼錯誤</p>
    <button @click="handleClick">確定</button>
  </div>
</template>

<style scoped lang="scss">
.wrong-sex-card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 290px;
  height: 129px;
  padding: 24px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  align-items: center;
  justify-content: space-between;
  p {
    color: $txt-color-grey-80;
    font-size: 18px;
    font-weight: 600;
  }
  button {
    width: 100%;
    border: none;
    background-color: #f74768;
    color: #ffffff;
    font-size: 16px;
    border-radius: 4px;
    padding: 8px 24px;
    cursor: pointer;
  }
}

.junior-landing-page > .main-content > .popup-overlay > .wrong-sex-card > button {
  background-color: $color-brownish-100;
}
</style>
